import { Root } from "./parts/Root";
import { PuzzleBoard } from "./parts/PuzzleBoard";
import { Reset } from "./parts/Reset";
import { Hint } from "./parts/Hint";

export const ChessPuzzle = {
  Root,
  Board: PuzzleBoard,
  Reset,
  Hint,
};
